import { useEffect, useState } from "react";
import { Loader2, MousePointerClick, Volume2, BookOpen, ListChecks } from "lucide-react";
import { api } from "@/lib/api";
import { BookPlayer } from "@/components/player/BookPlayer";
import { makeTracker } from "@/lib/tracking";

const fetchText = () => api.get("/public/books/demo-water-cycle/text").then((r) => r.data);
const fetchLines = () => api.get("/public/books/demo-water-cycle/lines").then((r) => r.data);
const onEvent = makeTracker("demo-water-cycle");
const onQuiz = (body) => api.post("/public/books/demo-water-cycle/quiz-attempts", body).then((r) => r.data);

export const LiveDemo = () => {
  const [manifest, setManifest] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { api.get("/public/demo").then((r) => setManifest(r.data)).catch(() => setFailed(true)); }, []);

  return (
    <section id="demo" className="mx-auto max-w-7xl px-6 py-16 md:px-10" data-testid="live-demo-section">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[#F7933E]">Experience an iBook · no sign-up</p>
          <h2 className="mt-2 font-display text-3xl font-bold sm:text-4xl">Turn the pages yourself.</h2>
          <p className="mt-3 max-w-xl text-[#64748B]">This is a real published iBookStudio book. Drag a page corner or use the arrows, open the pop-out buttons, tap hotspots, play the rain sounds and the NASA water-cycle video — then take the scored quiz on page 7.</p>
        </div>
        <div className="flex flex-wrap gap-3 text-xs font-semibold text-[#334155]">
          {[[BookOpen, "Drag a corner to turn"], [MousePointerClick, "Hotspots & pop-outs"], [Volume2, "Audio & video"], [ListChecks, "Scored quiz"]].map(([I, t]) => (
            <span key={t} className="neu-flat flex items-center gap-1.5 rounded-full px-3 py-1.5"><I className="h-3.5 w-3.5 text-[#3D3DF0]" />{t}</span>
          ))}
        </div>
      </div>
      <div className="neu-panel mt-10 overflow-hidden rounded-[32px] p-3">
        <div className="h-[560px] overflow-hidden rounded-[24px] sm:h-[680px]" data-testid="live-demo-player">
          {manifest ? <BookPlayer manifest={manifest} variant="embed" fetchText={fetchText} fetchLines={fetchLines} onQuiz={onQuiz} onEvent={onEvent} keyboard={false} /> : (
            <div className="grid h-full place-items-center text-sm text-[#64748B]">
              {failed ? "The demo book is being prepared — please refresh in a moment." : <Loader2 className="h-6 w-6 animate-spin text-[#3D3DF0]" />}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
